// Calc Module

class ShipCalc {
    constructor(containerSelector) {
        this.container = document.querySelector(containerSelector);
        if (!this.container) return;

        // Form elements
        this.version = this.container.getAttribute('data-site-version-code');
        this.length = this.container.querySelector('#calc-length');
        this.width = this.container.querySelector('#calc-width');
        this.height = this.container.querySelector('#calc-height');
        this.shipping = this.container.querySelector('#select-carriers');
        this.divisor = this.container.querySelector('#icd');
        this.form = this.container.querySelector('#calc-form');
        this.submit = this.container.querySelector('#calc-submit');
        this.resultsBlock = this.container.querySelector('.calculator__results');
        this.resultLength = this.container.querySelector('#strap-length');
        this.resultWeight = this.container.querySelector('#dimensional-weight');
        this.cta = this.container.querySelector('.calculator__cta-btn');

        this.strapLength = null;
        this.dimensionalWeight = null;

        this.hide(this.resultsBlock);

        this.bindEvents();
    }

    /* ------------------------------ */
    /* CORE CALCULATION */
    /* ------------------------------ */

    getNumber(element) {
        if (!element || element.value === '') return null;
        const value = parseFloat(element.value);
        return isNaN(value) ? null : value;
    }

    getStrap() {
        const l = this.getNumber(this.length);
        const w = this.getNumber(this.width);
        const h = this.getNumber(this.height);
        if (l === null || w === null || h === null) return null;
        return 2 * h + 2 * w + l;
    }

    getDimensional() {
        const l = this.getNumber(this.length);
        const w = this.getNumber(this.width);
        const h = this.getNumber(this.height);
        if (l === null || w === null || h === null) return null;

        let divisor = this.getNumber(this.divisor);

        if (divisor === null || divisor === undefined) {

            const value = this.shipping.value;
            const parts = value.split('-');

            divisor = parseFloat(parts[1]) || null;

        }

        if (divisor === null) return null;

        const volume = l * w * h;
        return this.version === 'se' ? volume * divisor : volume / divisor;
    }

    calculate() {
        const strap = this.getStrap();
        const dimensional = this.getDimensional();

        if (strap === null || dimensional === null) {
            this.clearResults();
            return;
        }

        this.strapLength = strap;
        this.dimensionalWeight = dimensional;

        this.renderResults();
    }

    renderResults() {
        this.setOutput(this.resultLength, this.strapLength.toFixed(1));
        this.setOutput(this.resultWeight, this.dimensionalWeight.toFixed(2));
        this.show(this.resultsBlock);
        if (this.cta) this.show(this.cta);
        if (this.submit) this.submit.setAttribute('disabled', 'disabled');
    }

    clearResults() {
        this.strapLength = null;
        this.dimensionalWeight = null;
        this.hide(this.resultsBlock);
        if (this.cta) this.hide(this.cta);
        if (this.submit) this.submit.removeAttribute('disabled');
    }

    /* ------------------------------ */
    /* HELPERS */
    /* ------------------------------ */

    setOutput(element, value) {
        if (!element) return;
        element.textContent = value;
    }

    show(element) {
        if (!element) return;
        element.style.opacity = 1;
        element.style.visibility = 'visible';
    }

    hide(element) {
        if (!element) return;
        element.style.opacity = 0;
        element.style.visibility = 'hidden';
    }

    /* ------------------------------ */
    /* EVENTS */
    /* ------------------------------ */

    bindEvents() {
        const self = this;

        [this.length, this.width, this.height, this.shipping, this.divisor].forEach(el => {
            if (!el) return;
            el.addEventListener('input', () => self.clearResults());
            el.addEventListener('change', () => self.clearResults());
        });

        if (this.form) {
            this.form.addEventListener('submit', function(e) {
                e.preventDefault();
                self.calculate();
            });
        }
    }
}

export default ShipCalc;


// WEBPACK FOOTER //
// ./scripts/modules/shipCalc.js